import axios from 'axios';
import { ElMessage } from 'element-plus';
// 创建axios实例
const api = axios.create({
    baseURL: '/api/v1',
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json'
    }
});
// 请求拦截器
api.interceptors.request.use((config) => {
    // 添加认证token
    const token = localStorage.getItem('admin_token');
    if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    console.error('请求错误:', error);
    return Promise.reject(error);
});
// 响应拦截器
api.interceptors.response.use((response) => {
    const { data } = response;
    // 统一响应格式处理
    if (data.code && data.code !== 200) {
        ElMessage.error(data.message || '请求失败');
        return Promise.reject(new Error(data.message || '请求失败'));
    }
    return data;
}, (error) => {
    console.error('响应错误:', error);
    if (error.response) {
        const { status, data } = error.response;
        switch (status) {
            case 401:
                ElMessage.error('未授权，请重新登录');
                localStorage.removeItem('admin_token');
                localStorage.removeItem('admin_user_info');
                window.location.href = '/login';
                break;
            case 403:
                ElMessage.error('权限不足');
                break;
            case 404:
                ElMessage.error('请求的资源不存在');
                break;
            case 500:
                ElMessage.error('服务器内部错误');
                break;
            default:
                ElMessage.error(data?.message || '网络错误');
        }
    }
    else if (error.code === 'ECONNABORTED') {
        ElMessage.error('请求超时');
    }
    else {
        ElMessage.error('网络连接异常');
    }
    return Promise.reject(error);
});
export default api;
export { api as http };
